import styles from "./index.module.scss";
import {Badge, Image, Table, Tag} from "antd";
import PrismCode from "../PrismCode";
import React, { useEffect, useRef } from "react";
// import mcCharts from './index.esm'

const columns = [
    {
        title: '名称',
        width: 180,
        dataIndex: 'name',
        align: 'left',
        render: (text, record) => <div>{text}{record.state ? (<div className={styles.badge}><Badge count={record.state === 'del' ? 'deprecated' : '2.6.0+'} showZero color={record.state === 'del' ? "#faad14" : "#52c41a"} /></div>) : ''}</div>
    },
    {
        title: '描述',
        width: 200,
        dataIndex: 'describe'
    },
    {
        title: '类型',
        dataIndex: 'type',
        render: (text) => <Tag color="orange">{text}</Tag>,
    },
    {
        title: '默认值',
        dataIndex: 'defVal'
    },
    {
        title: '必填',
        dataIndex: 'must',
        render: (text) => <Tag color={!text ? "#2db7f5" : '#f52d2d'}>{!text ? '非必填' : '必填'}</Tag>,
    },
    {
        title: '备注',
        dataIndex: 'remarks'
    }
];

function ModuleCode ({code, imgUrl, title, tips, dataSource, apiTitle }) {
    const chartRef = useRef(null);
    useEffect(() => {
        // const chart = mcCharts.init(chartRef.current);
        // const option = {
        //     // ECharts 配置项
        //     title: {
        //         text: '周销售额趋势'
        //     },
        //     xAxis: {
        //         name: '第一周',
        //         data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        //     },
        //     yAxis: {
        //         name: '销售额',
        //         data: 'value'
        //     },
        //     series: [
        //         {
        //             data: [1200, 2230, 1900, 2100, 3500, 4200, 3985],
        //             type: 'line'
        //         }
        //     ]
        // };
        // chart?.setOption(option);

    }, []);
    return (
        <div className={styles.module} id={(apiTitle || title).replace('属性', '')}>
            <div className={styles.title}>
                <span>#</span>{title}
            </div>
            <p>
                {tips}
            </p>
            <div className={styles.code}>
                <PrismCode collapse={false} code={code} language="js" plugins={['line-numbers']} />
                <div className={styles.previewImage} ref={chartRef}>
                    <Image
                        width={350}
                        src={imgUrl}
                    />
                </div>
            </div>
            {
                columns && dataSource ?
                    <div className={styles.apiList}>
                        <div className={styles.apiItem}>
                            <div className={styles.apiTitle}>{apiTitle}</div>
                            <Table  columns={columns} dataSource={dataSource} pagination={false}>
                            </Table>
                        </div>
                    </div>
                : ''
            }
        </div>
    )
}

export default ModuleCode
